module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__bd bm",
    attrs: {
      "id": "audit"
    }
  }, [_c('toobarhead', {
    attrs: {
      "showRefresh": false,
      "showBack": true,
      "titleName": '审核',
      "showBackTip": true
    }
  }), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "weui-cells weui-cells_form"
  }, [_c('div', {
    staticClass: "weui-cell weui-cell_select weui-cell_select-after"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.contractFlow.auditResult),
      expression: "contractFlow.auditResult",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "weui-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.contractFlow, "auditResult", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("审核不通过")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNotify),
      expression: "showNotify"
    }],
    staticClass: "weui-cell weui-cell_select weui-cell_select-after"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.contractFlow.isNotify),
      expression: "contractFlow.isNotify",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "weui-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.contractFlow, "isNotify", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRisk),
      expression: "showRisk"
    }],
    staticClass: "weui-cell weui-cell_select weui-cell_select-after"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.contractFlow.auditRisk),
      expression: "contractFlow.auditRisk",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "weui-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.contractFlow, "auditRisk", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不评估风险")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("一般、较大风险")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("重大风险")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCeoAudit),
      expression: "showCeoAudit"
    }],
    staticClass: "weui-cell weui-cell_select weui-cell_select-after"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.contractFlow.isCeoAudit),
      expression: "contractFlow.isCeoAudit",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "weui-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.contractFlow, "isCeoAudit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), (_vm.showNeedNo) ? _c('div', {
    staticClass: "weui-cell weui-cell_switch"
  }, [_c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("是否需要收货确认单")]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contractFlow.isNeedNo),
      expression: "contractFlow.isNeedNo"
    }],
    staticClass: "weui-switch",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.contractFlow.isNeedNo) ? _vm._i(_vm.contractFlow.isNeedNo, null) > -1 : (_vm.contractFlow.isNeedNo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contractFlow.isNeedNo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.contractFlow, "isNeedNo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.contractFlow, "isNeedNo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.contractFlow, "isNeedNo", $$c)
        }
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showRecover) ? _c('div', {
    staticClass: "weui-cell weui-cell_switch"
  }, [_c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("是否追回原件")]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contractFlow.isRecover),
      expression: "contractFlow.isRecover"
    }],
    staticClass: "weui-switch",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.contractFlow.isRecover) ? _vm._i(_vm.contractFlow.isRecover, null) > -1 : (_vm.contractFlow.isRecover)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contractFlow.isRecover,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.contractFlow, "isRecover", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.contractFlow, "isRecover", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.contractFlow, "isRecover", $$c)
        }
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contractFlow.content),
      expression: "contractFlow.content"
    }],
    staticClass: "weui-textarea",
    attrs: {
      "placeholder": "请输入文本",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.contractFlow.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contractFlow, "content", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-textarea-counter"
  }, [_c('span', [_vm._v(_vm._s(_vm.contentNum))]), _vm._v("/200")])])])]), _vm._v(" "), _c('div', {
    staticClass: "audit"
  }, [_c('button', {
    class: [{
      'weui-btn_disabled': !_vm.showSubmitBtn
    }, 'weui-btn weui-btn_primary'],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.audit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交审核")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dialogs"
    }
  }, [_c('div', {
    staticClass: "js_dialog",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "auditConfirmDlg"
    }
  }, [_c('div', {
    staticClass: "weui-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v("确定提交当前审核吗")]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel.apply(null, arguments)
      }
    }
  }, [_vm._v("放弃")]), _vm._v(" "), _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showAuditSuccessToast) ? _c('div', [_c('div', {
    staticClass: "weui-toast"
  }, [_c('i', {
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v("已完成")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAuditOperateToast),
      expression: "showAuditOperateToast"
    }],
    staticClass: "audit_loadingToast"
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTip),
      expression: "showTip"
    }],
    staticClass: "js_dialog"
  }, [_c('div', {
    staticClass: "weui-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v(_vm._s(_vm.tipContent))]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.showTip = false
      }
    }
  }, [_vm._v("知道了")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("审核结果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("是否股东大会/董事会决议并公告")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("评估风险")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("总经理审核")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("审核意见")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v("确认审核")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-toast"
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v("操作中...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v("操作被终止")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44faebbc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audit.vue
// module id = 140
// module chunks = 2